import { encrypt } from "../../../utils/jsencrypt";

export const PASSWORD_ENCRYPTION_FAILED = "PASSWORD_ENCRYPTION_FAILED";

export function createOgeAccountPayload(ogeUsername, password) {
	const encryptedPassword = encrypt(password);
	if (!encryptedPassword) {
		throw new Error(PASSWORD_ENCRYPTION_FAILED);
	}

	return {
		ogeUsername: ogeUsername.trim(),
		password: encryptedPassword,
	};
}
